export const refreshFileManager = (isTemplate?: boolean): void => {
	const buttonId = isTemplate
		? "templatesDocuments_tb_refresh"
		: "fileManager_tb_refresh";
	const refreshButton = document.getElementById(buttonId);
	setTimeout(function () {
		refreshButton?.click();
	}, 500);
};
